import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import MapPinLineIcon from 'remixicon-react/MapPinLineIcon';
import { Link } from 'react-router-dom';
import { PROJECT } from 'constants/routes';
import { ProjectType } from 'pages/projects/hooks/useProjectsQuery';
import Dot from 'components/common/dot/Dot';
import { useBuildWiseModules } from '@buildwise/libs/helpers';

const $ProjectSmallBoxWrapper = styled(Box, { label: 'ProjectSmallBoxWrapper' })(({ theme }) => ({
  width: '100%',
  paddingTop: 24,
  paddingBottom: 24,
  borderBottom: `1px solid ${theme.palette.custom.line}`,
  display: 'flex',
}));

const $ProjectTitle = styled(Typography, { label: 'ProjectTitle' })<{
  component: typeof Link;
  to: string;
}>(() => ({
  fontWeight: 600,
  fontSize: 18,
  lineHeight: '21px',
  letterSpacing: '0.25px',
  color: '#000000',
  marginBottom: 4,
  cursor: 'pointer',
}));

const $ProjectInfo = styled(Typography, { label: 'ProjectInfo' })(({ theme }) => ({
  fontWeight: 500,
  fontSize: 14,
  lineHeight: '20px',
  letterSpacing: '0.25px',
  color: theme.palette.custom.label,
  marginBottom: 4,
  display: 'flex',
  alignItems: 'center',
  '& > svg': {
    marginRight: 2,
  },
  '&.darker': {
    color: theme.palette.custom.activeTitle,
  },
}));

const ProjectSmallBox: FC<{ project: ProjectType }> = ({ project }) => {
  const { singularProjectsModuleName, pluralPartnersModuleName } = useBuildWiseModules();

  return (
    <$ProjectSmallBoxWrapper>
      <Box flexGrow={1}>
        <$ProjectTitle component={Link} to={PROJECT.replace(':projectId', project.id)}>
          {project.name}
        </$ProjectTitle>
        {(project.city || project.county || project.country_code) && (
          <Box display="flex">
            <$ProjectInfo className="darker">{project.city}</$ProjectInfo>
            {(project.county || project.country_code) && <Dot />}
            <$ProjectInfo>
              {(project.county || project.country_code) && <MapPinLineIcon size={16} />}{' '}
              {project.county}
              {project.county && project.country_code ? ',' : ''} {project.country_code}
            </$ProjectInfo>
          </Box>
        )}

        <Box display="flex">
          <$ProjectInfo>{project.projectAssociatedArticleCount || 0} Posts</$ProjectInfo>
          <Dot />
          <$ProjectInfo>
            {project.projectAssociatedUserCount || 0} {singularProjectsModuleName} Members
          </$ProjectInfo>
          <Dot />
          <$ProjectInfo>
            {project.contacts?.length || 0} {pluralPartnersModuleName}
          </$ProjectInfo>
        </Box>
      </Box>
    </$ProjectSmallBoxWrapper>
  );
};

export default ProjectSmallBox;
